import { fullName, age, college } from '../../constants/personalInfo/personalInfo.ts';

/**
 * Translation resources for the about me component.
 */
export interface AboutMeResourceTranslations {
    greeting: string;
    summary: string;
    introduction: string;
    focusBesideCollege: string;
    futureInterests: string;
}

/**
 * Overall about me translation resources structure.
 */
interface AboutMeResource {
    [language: string]: AboutMeResourceTranslations;
}

export const aboutMeResource: AboutMeResource = {
    nl: {
        greeting: 'Hallo! Ik ben',
        summary: '<role>Softwareontwikkelaar</role> met een passie voor Python, het bouwen van duidelijke en gestructureerde projecten, en het ontdekken van nieuwe technologieën.',
        introduction: `Mijn naam is ${fullName}, ik ben ${age} jaar oud en ik volg de opleiding Software Developer aan het ${college.name} in ${college.location}, met een focus op <collegeFocus>Python</collegeFocus> en <collegeFocus>front-endontwikkeling</collegeFocus>.`,
        focusBesideCollege: 'Naast mijn studie werk ik aan persoonlijke projecten in <personalFocus>TypeScript</personalFocus> om mijn programmeervaardigheden verder te ontwikkelen.',
        futureInterests: 'In de toekomst wil ik me verdiepen in <futureInterests>kunstmatige intelligentie</futureInterests> en <futureInterests>data science</futureInterests>, omdat ik de mogelijkheden en toepassingen binnen deze gebieden erg interessant vind.'
    },
    en: {
        greeting: 'Hello! I\'m',
        summary: '<role>Software Developer</role> passionate about Python, building clean and well-structured projects, and exploring new technologies.',
        introduction: `My name is ${fullName}, I'm ${age} years old, and I am studying Software Development at ${college.name} in ${college.location}, with a focus on <collegeFocus>Python</collegeFocus> and <collegeFocus>front-end development</collegeFocus>.`,
        focusBesideCollege: 'Alongside my studies, I work on personal projects using <personalFocus>TypeScript</personalFocus> to further develop my programming skills.',
        futureInterests: 'In the future, I hope to explore <futureInterests>artificial intelligence</futureInterests> and <futureInterests>data science</futureInterests>, as I find the possibilities and applications in these fields very interesting.'
    }
};